import React,{useState} from "react";
import { Dropdown, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import photo from '../../../assets/images/top_uni3.png';
import { Rating } from 'react-simple-star-rating'

const Rightside = () => {

  const [list, setList] = useState(false);

  const [ratingValue,  setRatingValue] = useState(0) // initial rating v
  const handleRating = (rate)  => {
    setRatingValue(rate)
  }
  // Catch Rating value
    const handleReset =() => {
      setRatingValue(4)
    // other logic
  }

    return (
      <div className="listing_side_view">
           <div className="listing_side_main_set_wrap">
                <div className="subscribe">
                    <div className="left">
                        <Form>
                          <Form.Group className="form_search" controlId="exampleForm.ControlInput1">
                            <Form.Control type="email" placeholder="Course, University" />
                          </Form.Group>
                        </Form>
                    </div>
                    <div className="right">
                        <Form>
                          <Form.Group className="form_search" controlId="exampleForm.ControlInput1">
                            <Form.Control type="email" placeholder="Location" />
                          </Form.Group>
                          <div className="subscribe_btn">
                              <Link to='/'>
                                  <i class="fal fa-search"></i>
                              </Link>
                          </div>
                        </Form>
                    </div>
                </div>
                <div className="listing_head_wrap">
                    <div className="left">
                          <p>46 <span>listing found</span></p>
                    </div>
                    <div className="right">
                        <div className="sort_by_warp">
                              <ul>
                                  <li>
                                    <div className="sort_by_swap">
                                      <div className="left">
                                          <p>Sort by</p>
                                      </div>
                                      
                                      <div className="right">
                                          <Dropdown>
                                            <Dropdown.Toggle  id="dropdown-basic">
                                            Newest
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                  <div className="listing_view">
                                        <Link className={!list ?  'active' : "inactive"} onClick={()=> setList(false)}>
                                          <i class="fal fa-border-all"></i>
                                        </Link>
                                        <Link className={list ?  'active' : ""}   onClick={()=> setList(true)}>
                                          <i class="fal fa-bars"></i>
                                        </Link>
                                    </div>
                                  </li>
                              </ul>
                        </div>
                    </div>
                </div>
                <div className="lsiting_show_wrap">
                     <div className="list_grid">
                          <div className={list ? "list_grid_wrap list_single" : "list_grid_wrap"}>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                                <div className="listing_box">
                                    <div className="listing_one_third">
                                        <div className="space_sprate">
                                          <div className="img_area">
                                                <img src={photo} alt="" />
                                                <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                                </div>
                                          </div>
                                          <div className="detail_below">
                                              <div className="single_view">
                                                  <div className="name">
                                                      <div className="left">
                                                            <p>Penn State University</p>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                <i class="fas fa-star"></i>
                                                                4.0
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="descrpt">
                                                      <p>
                                                        Lorem ipsum dolor sit amet, con sectetur adipiscing elit. 
                                                      </p>
                                                  </div>
                                                  <div className="location">
                                                      <div className="left">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                      </div>
                                                      <div className="right">
                                                            <p>
                                                                PA 16801, United States
                                                            </p>
                                                      </div>
                                                  </div>
                                                  <div className="rating_area">
                                                      <Rating
                                                          onClick={handleRating}
                                                          ratingValue={ratingValue}
                                                          showTooltip={true}
                                                          initialValue={3.8}
                                                          readonly
                                                          tooltipDefaultText= "0"
                                                          tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                      />
                                                  </div>
                                                  <div className="courses">
                                                    <ul>
                                                      <li>
                                                        <Link to='/' className="listing_button">Public</Link>
                                                      </li>
                                                      <li>
                                                        <Link to='/' className="listing_button">50+ Course</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">Estd. 1990</Link>
                                                      </li>
                                                      <li className="other">
                                                        <Link to='/' className="listing_button">2k+ students</Link>
                                                      </li>
                                                    </ul>
                                                  </div>
                                              </div>
                                              <div className="apply">
                                                  <Link to='/' className="btn-primary-3">Apply now</Link>
                                              </div>
                                              <div className="wishlist">
                                                    <Link to='/'><i class="fal fa-bookmark"></i></Link>
                                              </div>
                                          </div>
                                        </div>
                                         <div className="apply">
                                             <Link to='/' className="btn-primary-3 w-100">Apply now</Link>
                                         </div>
                                    </div>
                                </div>
                          </div>
                     </div>
                </div>
           </div>
      </div>
    );
}

export default Rightside;
